import axios from 'axios';

export default {
    methods: {
        getHistory(options) {
            axios.get(process.env.VUE_APP_LARAVEL_ENDPOINT + "/api/user/history", {
                params: options
            })
                .then((response) => {
                    this.history = response.data.history.data;
                })
                .catch((error) => {
                    if (error.response) {
this.errors.push(error.response.data.message);}
else {
this.errors.push(error)}
                })
        }
    }
}